/**
 * Configurazione API per BustaControllo
 * Rileva automaticamente se l'app è in esecuzione su Capacitor nativo (iOS/Android)
 * e usa l'URL assoluto del backend invece di quello relativo.
 */

// URL del backend di produzione
const PRODUCTION_API_URL = 'https://bustacontrollo.com/api';

/**
 * Restituisce l'URL base dell'API.
 * - Su Capacitor nativo (iOS/Android): usa l'URL assoluto del backend
 * - Su web: usa l'URL relativo '/api'
 */
export function getApiUrl() {
  if (typeof window === 'undefined') return '/api';

  // Controlla il protocollo Capacitor (ios/android native app)
  const protocol = window.location?.protocol || '';
  if (protocol === 'capacitor:' || protocol === 'ionic:') {
    return PRODUCTION_API_URL;
  }

  // Controlla via window.Capacitor (bridge nativo)
  if (window.Capacitor && window.Capacitor.isNativePlatform()) {
    return PRODUCTION_API_URL;
  }

  // Controlla via window.Capacitor.getPlatform
  if (window.Capacitor && ['ios', 'android'].includes(window.Capacitor.getPlatform?.())) {
    return PRODUCTION_API_URL;
  }

  // Su web, usa l'URL relativo (funziona con il proxy del server)
  return '/api';
}

export const API_URL = getApiUrl();
